<script setup lang="ts">
import { hoverBgColor500p25, hoverTextColor500, textColor500 } from '@/globals/tailwind.ts'
import PhIcon from '@/components/PhIcon.vue'
import type { ColorKey } from '@/types/tailwind'

withDefaults(
  defineProps<{
    icon?: string
    color?: ColorKey
    text: string
    desc?: string
    active?: boolean
  }>(),
  {
    icon: '',
    color: 'blue',
    active: false,
  },
)
</script>

<template>
  <div
    :class="[
      hoverBgColor500p25[color],
      hoverTextColor500[color],
      icon ? 'gap-3' : '',
      active ? 'bg-stone-100 dark:bg-black/25' : '',
    ]"
    class="flex cursor-pointer px-3 py-2 rounded-lg transition-all duration-150"
  >
    <div v-if="icon" :class="textColor500[color]" class="mt-0.5">
      <ph-icon :name="icon"></ph-icon>
    </div>
    <div class="text-left">
      <span class="block font-serif text-sm capitalize">{{ text }}</span>
      <span v-if="desc" class="block mt-0.5 text-stone-500 text-xs first-letter:uppercase">{{
        desc
      }}</span>
    </div>
  </div>
</template>

<style scoped></style>
